import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { format, parseISO } from 'date-fns';
import './css/HeaderMain.scss';

function HeaderLoan({ loan }) {
    return (
        <Container className="header">
            <Row>
                <Col>
                    <h1>
                        {loan && loan.applicant && (
                            <>
                            {`${loan.applicant.lastName}, ${loan.applicant.firstName} ${loan.applicant.middleName} `}
                            </>
                        )}
                        {loan ? `[${loan.loanProcessingType} - ₱${parseFloat(loan.amountGranted).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')} - ${format(parseISO(loan.dateGranted), 'MM/dd/yyyy')}]` : "Loan Not Found"}
                    </h1>
                </Col>
            </Row>
        </Container>
    );
}

export default HeaderLoan;
